import {cloneDeep} from "lodash-es";

const getTree = (data, key, value, findArr, platKey) => {
  for (let i = 0; i < data.length; i++) {
    const item = {...data[i], ...platKey ? data[i][platKey] : {} };

    if (new RegExp(value).test(item[key])) {
      findArr.push(item)
    } else {
      // item.children 不等于 undefined && item.children.length 大于 0 时
      if (item.children && item.children.length > 0) {
        const res = getTree(item.children, key, value, findArr);
        // 当 res = undefined 时不会进入判断中
        // 也就是不会return
        if (res) return res;
      }
    }
  }
}
export const onMatchFormSearch = (value: Record<string, any>, tree: any[], platKey: string) => {
  const searchTree = cloneDeep(tree)
  const key = Object.keys(value)?.[0]
  let findArr: any[] = []
  if (key && value[key]) {
    getTree(searchTree, key, value[key], findArr, platKey)
  } else {
    findArr = tree
  }
  return findArr
}
